import { render, staticRenderFns } from "./InfoCoach.vue?vue&type=template&id=7aa4ec9a&scoped=true"
import script from "./InfoCoach.vue?vue&type=script&lang=js"
export * from "./InfoCoach.vue?vue&type=script&lang=js"
import style0 from "./InfoCoach.vue?vue&type=style&index=0&id=7aa4ec9a&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa4ec9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7aa4ec9a')) {
      api.createRecord('7aa4ec9a', component.options)
    } else {
      api.reload('7aa4ec9a', component.options)
    }
    module.hot.accept("./InfoCoach.vue?vue&type=template&id=7aa4ec9a&scoped=true", function () {
      api.rerender('7aa4ec9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportCenter/components/InfoCoach.vue"
export default component.exports